import * as React from 'react';
import { SVGProps } from 'react';
const SvgBackSm = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m3 12.762 6.373 6.262 1.215-1.203-4.284-4.21h14.105v-1.698H6.304l4.284-4.21L9.373 6.5 3 12.762Z"
      fill="current"
    />
  </svg>
);
export default SvgBackSm;
